export default __webpack_public_path__ + "static/media/logo.950e21b6.svg";